import React from "react";
import Blogs from "../components/blog";
import BlogContent from "../components/blogContent";
import Footer from "../components/footer";
import Header from "../components/header";

const BlogShow = () => {
  return (
    <div>
      <Header />
      <BlogContent />
      <Footer />
    </div>
  );
};

export default BlogShow;
